<template>
<span>
  <AlgoliaSelectedFiltersWatcher />
  <v-menu offset-y v-if="checkedOnPageCount > 0 || generalApp.allSelectedFilters.length > 0">
    
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon medium
            v-on="{ ...tooltip, ...menu }"
            :loading="loading"
          >
            <v-icon color="#757575">local_printshop</v-icon>
          </v-btn>
        </template>
        <span>{{$t('print_files.export_shipments_list')}}</span>
      </v-tooltip>
    </template>
    <v-list>
      <v-list-item @click="exportShipmentListPdf">
        <v-list-item-title>PDF</v-list-item-title>
      </v-list-item>
      <v-list-item @click="exportShipmentListCsv">
        <v-list-item-title>CSV</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</span>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { algoliaService } from '@/_services'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import Roboto from '@/assets/fonts/Roboto-Regular-normal.js'
import RobotoBold from '@/assets/fonts/Roboto-Bold-bold.js'
import AlgoliaSelectedFiltersWatcher from '@/components/general/AlgoliaSelectedFiltersWatcher'
import * as Sentry from '@sentry/browser'

export default {
  name: 'ExportShipmentList',
  components: {
    AlgoliaSelectedFiltersWatcher
  },
  props: {
    dialog: Boolean
  },
  data () {
    return {
      loading: false,
      head: [],
      body: [],
      rows: [],
      filteredShipments: null,
      departure: null,
      arrival: null,
      company: null,
      weight: null,
      volume: null,
      route: [],
      status: null
    }
  },
  computed: {
    ...mapGetters(['getActualListPage', 'getCheckedOnPage', 'getCheckedOnPageCount']),
    ...mapGetters('cognito', ['userAttributes']),
    ...mapState(['generalApp']),
    actualPage () {
      return this.getActualListPage
    },
    checkedOnPage () {
      return this.getCheckedOnPage(this.actualPage)
    },
    checkedOnPageCount () {
      return this.getCheckedOnPageCount(this.actualPage)
    }
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar'
    }),
    async getFilteredData () {
      let result = await algoliaService.getFilteredHits('prod_shipments_v2', 1000, this.generalApp.allSelectedFilters)
      this.filteredShipments = result.hits
    },
    sortShipmentData (data) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].labels.length; j++) {
          data.sort((a, b) => {
            // sorts first by departure date and if date is the same sorts by labels
            if (a.pickupLocal.from > b.pickupLocal.from) return 1
            if (a.pickupLocal.from < b.pickupLocal.from) return -1

            if (a.labels[j] > b.labels[j]) return 1
            if (a.labels[j] < b.labels[j]) return -1
          })
        }
      }
    },
    filteredFileData (filteredShipments, i) {
      this.departure = null
      this.arrival = null
      this.company = null
      this.weight = null
      this.volume = null
      this.route = []
      this.status = null

      this.departure = this.$options.filters.dateToReadableFullMoment(this.filteredShipments[i].pickupLocal.from, this.$i18n.locale)
      this.arrival = this.$options.filters.dateToReadableFullMoment(this.filteredShipments[i].deliveryLocal.from, this.$i18n.locale)
      if(this.filteredShipments[i].carrierAssigned === false) {
        this.company = 'N/A'
      } else if (this.filteredShipments[i].carrierAssigned === true) {
        this.company = this.filteredShipments[i].carrierAssigned
      }
      this.weight = this.$options.filters.roundValueWeight(this.filteredShipments[i].weight, 0)
      this.volume = this.$options.filters.roundValue(this.filteredShipments[i].volume, 1)
      if (this.filteredShipments[i].labels.length > 0) {
        for (let j = 0; j < this.filteredShipments[i].labels.length; j++) {
          this.route.push(this.filteredShipments[i].labels[j])
        }
      } else {
        this.route.push('N/A')
      }
      this.status = this.filteredShipments[i].status
    },
    fileData (shipmentData, i) {
      this.departure = null
      this.arrival = null
      this.company = null
      this.weight = null
      this.volume = null
      this.route = []
      this.status = null

      this.departure = this.$options.filters.dateToReadableFullMoment(shipmentData[i].pickupLocal.from, this.$i18n.locale)
      this.arrival = this.$options.filters.dateToReadableFullMoment(shipmentData[i].deliveryLocal.from, this.$i18n.locale)
      if(shipmentData[i].carrierAssigned === false) {
        this.company = 'N/A'
      } else if (shipmentData[i].carrierAssigned === true) {
        this.company = shipmentData[i].carrierAssigned
      }
        this.weight = this.$options.filters.roundValueWeight(shipmentData[i].weight, 0)
        this.volume = this.$options.filters.roundValue(shipmentData[i].volume, 1)
        if(shipmentData[i].labels.length > 0) {
        for (let j = 0; j < shipmentData[i].labels.length; j++) {
          this.route.push(shipmentData[i].labels[j])
        }
        } else {
          this.route.push('N/A')
        }
        this.status = shipmentData[i].status
    },
    async exportShipmentListPdf () {
      // console.log(this.generalApp.allSelectedFilters)
      this.loading = true
      let Pdf = jsPDF
      let doc = new Pdf('landscape')
      // font to Roboto so we won't have problems with encoding
      doc.addFileToVFS('Roboto-Regular.ttf', Roboto)
      doc.addFileToVFS('Roboto-Bold.ttf', RobotoBold)
      doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal')
      doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold')
      doc.setFont('Roboto')
      doc.setFontSize(14)
      this.head = []
      this.body = []
      this.head.push(
        [
          { content: this.$i18n.t('print_files.departure') },
          { content: this.$i18n.t('print_files.arrival') },
          // { content: this.$i18n.t('print_files.shipment_type') },
          { content: this.$i18n.t('print_files.company') },
          { content: this.$i18n.t('print_files.weight') + ' [KG]' },
          { content: this.$i18n.t('print_files.volume') + ' [CBM]' },
          { content: this.$i18n.t('print_files.route') },
          { content: this.$i18n.t('print_files.status') }
        ]
      )
      if (this.generalApp.allSelectedFilters.length > 0 && !this.checkedOnPageCount) {
        // this will print all the filtered shipments if there are any
        await this.getFilteredData()
        // sort the filtered shipments
        this.sortShipmentData(this.filteredShipments)
        try {
          for (let i = 0; i < this.filteredShipments.length; i++) {
            this.filteredFileData(this.filteredShipments, i)
            this.body.push([this.departure, this.arrival, this.company, this.weight, this.volume, this.route.join(', '), this.status])
          }
        } catch (err) {
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
      } else if (this.checkedOnPageCount > 0) {
        // this will print all the selected shipments if there are any
        let shipmentData = Object.values(this.checkedOnPage)
        // sort the data
        this.sortShipmentData(shipmentData)
        // console.log(shipmentData)
        try {
          for (let i = 0; i < shipmentData.length; i++) {
            this.fileData(shipmentData, i)
            this.body.push([this.departure, this.arrival, this.company, this.weight, this.volume, this.route.join(', '), this.status])
          }
        } catch (err) {
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
        
      }
      if (this.body.length > 0) {
        doc.setFontStyle('bold')
        doc.text(this.$i18n.t('print_files.shipments_list').toUpperCase(), 130, 10)

        doc.setFontStyle('normal')
        doc.autoTable({
          head: this.head,
          body: this.body,
          styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
          theme: 'grid',
          rowPageBreak: 'avoid',
          headStyles: { fillColor: [255, 255, 255], lineWidth: 0.1 },
          columnStyles: { 0: { cellWidth: 28 }, 1: { cellWidth: 28 },  3: { halign: 'right', cellWidth: 20 }, 4: { halign: 'right', cellWidth: 20 } },
          startY: 20
        })

        let pageCount = doc.internal.getNumberOfPages()
        let dateObj = new Date()
        let day = dateObj.getDate()
        // months in js are indexed from 0
        let month = dateObj.getMonth() + 1
        let year = dateObj.getFullYear()
        let hour = dateObj.getHours()
        // adds 0 in front of minutes when needed
        let minute = String(dateObj.getMinutes()).padStart(2, '0')
        let newDate = day + '/' + month + '/' + year
        let newTime = hour + ':' + minute
        for (let i = 0; i < pageCount; i++) {
          doc.setFontSize(14)
          doc.setPage(i)
          doc.text(262, 10, this.$i18n.t('print_files.pages') + ': ' + doc.internal.getCurrentPageInfo().pageNumber + '/' + pageCount)
          doc.setFontSize(9)
          doc.text(14, 203, `${this.$i18n.t('print_files.printed')} ${newDate} ${this.$i18n.t('print_files.at')} ${newTime} ${this.$i18n.t('print_files.by')} ${this.userAttributes.email}`)
          doc.text(244, 203, this.$i18n.t('print_files.generated'))
        }
        try {
          doc.save(`${this.$i18n.t('print_files.shipment_list_file_name')}.pdf`)
        } catch (err) {
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          Sentry.captureException(err)
          this.loading = false
        }
        this.loading = false
      }
    },
    async exportShipmentListCsv () {
      this.loading = true
      this.rows = []
      let csvContent = 'data:text/csv;charset=utf-8,'
      this.rows.push([this.$i18n.t('print_files.departure'), this.$i18n.t('print_files.arrival'), this.$i18n.t('print_files.company'), this.$i18n.t('print_files.weight') + ' (KG)', this.$i18n.t('print_files.volume') + ' (CBM)', this.$i18n.t('print_files.route'), this.$i18n.t('print_files.status')])
      if (this.generalApp.allSelectedFilters.length > 0 && !this.checkedOnPageCount) {
        await this.getFilteredData()
        // sorts the filtered data
        this.sortShipmentData(this.filteredShipments)
        try {
          for (let i = 0; i < this.filteredShipments.length; i++) {
            this.filteredFileData(this.filteredShipments, i)
            this.rows.push([this.departure, this.arrival, this.company, this.weight, this.volume, this.route, this.status])
          }
        } catch (err) {
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
      } else if (this.checkedOnPageCount > 0) {
        let shipmentData = Object.values(this.checkedOnPage)
        this.sortShipmentData(shipmentData)
        try {
          for (let i = 0; i < shipmentData.length; i++) {
            this.fileData(shipmentData, i)
            this.rows.push([this.departure, this.arrival, this.company, this.weight, this.volume, this.route, this.status])
          }
        } catch (err) {
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
      }

      if (this.rows.length > 1) {
        this.rows.forEach(function (rowArray) {
          let row = rowArray.join(';').replace(',', '-')
          csvContent += row + '\r\n'
        })
        try {
          let encodedUri = encodeURI(csvContent)
          let link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          link.setAttribute('download', `${this.$i18n.t('print_files.shipment_list_file_name')}.csv`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } catch (err) {
          Sentry.captureException(err)
          this.loading = false
        }
        
      }
      this.loading = false
    }
  },
  created () {}
}
</script>

<style lang="scss" scoped>

</style>
